
	import {
		Component,
		Prop,
		Vue
	} from "vue-property-decorator";
	import Cookies from "js-cookie";

	import Loading from "@components/Loading.vue";
	import Footer from "../../components/Footer.vue";
	import HeaderLayout from "../Components/header.vue";
	import Confirm from "./Modules/Confirm.vue";
	import Pay from "./Modules/Pay.vue";
	import Ticket from "./Modules/Ticket.vue";
	import Write from "./Modules/Write.vue";

	import {
		Flags
	} from "./Models/index";
	import {
		IMeetingInfo
	} from "@/contants/current.ts";
	import {
		IPostSignMeetingUser
	} from "@/api/modules/signup/index.dto";
	import {
		ITicketParams
	} from "./Interfaces/ticket";

	@Component({
		components: {
			Confirm,
			Pay,
			Ticket,
			Write,
			HeaderLayout,
			Footer,
			Loading
		},
	})
	export default class SignUp extends Vue {
		private flags = Flags;
		private m: string = "";
		private headData: any = {};
		private ticketModalsDatas: any = {
			SignUpSetType: []
		};
		private SignUpSetType: number = 0;
		private formDatas: any = {
			form_Sets: []
		};
		private confirmDatas: any = {};
		private payDatas: any = {};
		
		created() {
			const {
				m
			} = this.$route.query;
			this.m = String(m);
			this.InitMeetingInfo();
		}
		/**
		 * @description: 获取会议基本信息
		 */
		async InitMeetingInfo() {
			this.flags.showLoading = true;
			let params = {
				m: this.m,
			};
			let res = await IMeetingInfo.InitMeetingInfo(params);

			if (res.Code === 1000) {
				this.headData = res;
				this.flags.showLoading = false;
				this.InitSignConfig();
			}
		}
		/**
		 * @description: 报名配置数据
		 */
		async InitSignConfig() {
			this.flags.moduleLoading = true;
			let params: any = {
				m: this.m,
			};
			let Res: any = await this.$http.SignUp.InitSignConfig(params);
			if (Res.Code === 1000) {
				this.ticketModalsDatas = Res["signUp_Set"];
				this.SignUpSetType = this.ticketModalsDatas.SignUpSetType.length;
				this.formDatas.form_Sets = Res["form_Sets"];
				this.formDatas.is_multiuser = Res["signUp_Set"].is_multiuser;
				this.formDatas.SignUpSetType = Boolean(this.SignUpSetType);
				this.formDatas.is_vip = Res["signUp_Set"].is_vipcheck;
				this.flags.moduleLoading = false;
			} else if (Res.Code === 6004 || Res.Code === 7001) {
				const {
					ch,
					channelId,
					red
				} = this.$route.query;

				let _link = red == "no" ? "" : Res.signUp_Set.jump_link;
				if (_link) {
					let _url = channelId !== undefined ? channelId : ch;
					if (_link.indexOf("{channid}") !== -1) {
						_link = _link.replace("{channid}", _url);
					}
					if (_link.indexOf("userid") !== -1) {
						_link = _link.replace("{userid}", Res.keyid);
						window.location.href = _link;
					} else {
						window.location.href = _link;
					}
				} else {
					this.$router.push({
						path: "/personalCenter",
						query: this.$route.query,
					});
				}
			}

			// console.log("报名配置总数据", Res);
			// console.log("表单配置数据", this.formDatas.form_Sets);
			// console.log("票总数据", this.ticketModalsDatas);
		}
		/**
		 * @description: 判断上一步还是下一步
		 */
		handleClickBtn(type: string) {
			if (type === "back") {
				if (this.flags.active != 0) {
					this.flags.active--;
				}
			} else {
				this.flags.active++;
				return true;
			}
		}
		/**
		 * @description: 选择的票种的数据
		 */
		handleGetTicketData(data: ITicketParams) {
			const {
				type
			} = data;
			this.confirmDatas.ticket = data;
			console.log("选择的票", data);
			if (this.handleClickBtn(type)) {
				this.formDatas.count = data.count;
			}
			this.ticketModalsDatas.ssl_count = data.count;
			this.ticketModalsDatas.sslDatas = data;
		}
		/**
		 * @description: 用户填写的表单信息
		 */
		handleGetFormData(data: any) {
			const {
				type
			} = data;
			this.formDatas.Datas = data.UserEntity;
			this.confirmDatas.UserEntity = data.UserEntity;
			this.confirmDatas.count = this.formDatas.count;
			this.confirmDatas.is_vip = data.is_vip;

			console.log("用户填写的表单信息", data);
			this.handleClickBtn(type);
		}
		/**
		 * @description: 确认报名
		 */
		handleConfirmInfo(data: any) {
			// console.log(data);
			this.handleClickBtn(data.type);
		}
		/**
		 * @description: 去支付
		 */
		handleToPay(data: any) {
			const {
				type
			} = data;
			if (type === "pay") {
				console.log(data);
			} else {
				this.flags.active--;
			}
		}
		async submitSignUp(data: IPostSignMeetingUser, type: any) {
			// let res = await this.$http.SignUp.PostSignMeetingUser(data);
			// this.handleClickBtn(type);
			// console.log(res);
		}
	}
